import angular from 'angular';
import uiRouter from 'angular-ui-router';
import authComponent from './auth.component';

let authModule = angular.module('auth', [
  uiRouter
])

.component('auth', authComponent)
.config(($stateProvider) => {
  "ngInject";

  $stateProvider
    .state('auth', {
      url: '',
      component: 'auth'
    });
})
.name;

export default authModule;



// WEBPACK FOOTER //
// ./client/app/components/auth/auth.js